export enum AlertCluster {
  TPMS = 'TPMS',

  CAN = 'CAN',

  EBS = 'EBS',

  DEFAULT = 'DEFAULT',

  OTHERS = 'OTHERS',
}
